import { TemplateVersion } from './types';

// Builds the document_templates collection URL.
// The global API pagination caps collections at 10 (pagination_items_per_page),
// which silently truncated the template list to the first 10 of N (#342).
// ponytail: 200 = pagination_maximum_items_per_page; add real paging if a company exceeds it.
export const TEMPLATES_PAGE_SIZE = 200;

export function buildTemplatesUrl(apiUrl: string, filterType?: string): string {
    const params = new URLSearchParams({ itemsPerPage: String(TEMPLATES_PAGE_SIZE) });
    if (filterType && filterType !== 'all') {
        params.set('type', filterType);
    }
    return `${apiUrl}/document_templates?${params.toString()}`;
}

export function parseVersionsResponse(data: any): TemplateVersion[] {
    if (Array.isArray(data)) return data;
    const members = data?.['hydra:member'];
    return Array.isArray(members) ? members : [];
}

export async function fetchVersionContent(
    apiUrl: string,
    templateId: number,
    versionNumber: number,
    token: string,
    fetchFn: typeof fetch = fetch,
): Promise<string | null> {
    const res = await fetchFn(`${apiUrl}/document-templates/${templateId}/versions/${versionNumber}`, {
        headers: { Authorization: `Bearer ${token}` },
    });
    if (!res.ok) return null;
    const data = await res.json();
    return data?.contentHtml ?? null;
}
